import React from 'react';
import { EventNameNav, EventNameNavProps } from '../components/EventNameNav';
import { WebsiteHeaderLayout_PhotoArch } from '../../../../hooks/useWebsiteHeaderSettings';
import { HeaderPhoto } from '../components/HeaderPhoto/HeaderPhoto';
import { PhotoArch } from '@apps/guest/packages/layout-engine/widgets/Custom/components';
import { useColorPaletteProvider } from '../../../../ColorPaletteProvider/ColorPaletteProvider';

interface PhotoArchLayoutProps extends EventNameNavProps {
  websiteHeader: WebsiteHeaderLayout_PhotoArch;
  showPlaceholder?: boolean;
}

export const PhotoArchLayout = (props: PhotoArchLayoutProps) => {
  const { websiteHeader, showPlaceholder = false, ...restProps } = props;

  const photo = websiteHeader.headerPhoto.photos?.[0];

  const { pageColor, pageFontColor } = useColorPaletteProvider();

  return (
    <EventNameNav
      eventDisplayName={websiteHeader.eventDisplayName}
      {...restProps}
    >
      <HeaderPhoto
        websiteHeader={websiteHeader}
        pageSlug={restProps.pageSlug}
        pageType={restProps.page}
        showPlaceholder={showPlaceholder}
      >
        <PhotoArch
          photo={photo}
          showPlaceholder={showPlaceholder}
          innerArchColor={pageColor}
          outerArchColor={pageFontColor}
        />
      </HeaderPhoto>
    </EventNameNav>
  );
};
